import { Button, Input } from "@ui";
import style from "./Export.module.scss";
import { useState } from "react";
import cn from "classnames";

export function Export() {
    const [activeService, setActiveService] = useState<"1" | "2">("1")

    return (
        <div className={style.container}>
            <div className={style.listServices}>
                <button
                    className={cn(style.button, activeService === "1" && style.button_active)}
                    onClick={() => setActiveService("1")}
                >
                    Сервіс 1
                </button>
                <button
                    className={cn(style.button, activeService === "2" && style.button_active)}
                    onClick={() => setActiveService("2")}
                >
                    Сервіс 2
                </button>
            </div>
            <div className={style.data}>
                <Input
                    value="178.151.69.50:7032:user:32:Rd6SwYDG"
                    onChange={() => { }}
                    actions="copy"
                    customStyle={{
                        width: "!max-w-full !w-full"
                    }}
                />
                <Input
                    value="http://................................................"
                    onChange={() => { }}
                    actions="copy"
                    customStyle={{
                        width: "!max-w-full !w-full"
                    }}
                />
                <Input
                    value="http://................../178.151.69.50:7032:user:32:Rd6SwYDG"
                    onChange={() => { }}
                    actions="copy"
                    customStyle={{
                        width: "!max-w-full !w-full"
                    }}
                />
            </div>
            <div className={style.actions}>
                <Button
                    text="Копіювати"
                    color="blue"
                    variant="outline"
                    customStyle={{
                        button: "!px-[40px] !py-[11px] max-sm:!hidden"
                    }}
                />
                <Button
                    text="Експортувати"
                    customStyle={{
                        button: "!px-[40px] !py-[11px]"
                    }}
                />
            </div>
        </div>
    )
}